import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle2, Calendar, Clock, MapPin, MessageCircle, Mail, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const Success = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const batch = location.state?.batch || 'MORNING';

  const batchTimes = {
    'MORNING': '10:00 AM - 01:00 PM',
    'EVENING': '03:00 PM - 06:00 PM'
  };

  return (
    <div className="success-page">
      <div className="container">
        <motion.div 
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="success-card"
        >
          <div className="success-icon-wrapper">
            <motion.div 
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", damping: 12, stiffness: 200, delay: 0.2 }}
            >
              <CheckCircle2 size={80} className="success-icon" />
            </motion.div>
          </div>

          <h1 className="success-title">Registration Successful!</h1>
          <p className="success-subtitle">You're all set for the Building Autonomous AI Agents Workshop.</p>

          <div className="event-details-box">
            <div className="detail-row">
              <Calendar size={18} />
              <span>May 6, 2026</span>
            </div>
            <div className="detail-row">
              <Clock size={18} />
              <span>{batchTimes[batch]} IST</span>
            </div>
            <div className="detail-row">
              <MapPin size={18} />
              <span>57/57b, Rajakkamangalam Rd, Nagercoil, Tamil Nadu 629170</span>
            </div>
          </div>

          <div className="instructions">
            <Mail size={20} className="instruction-icon" />
            <p>A confirmation email with your entry pass has been sent to your registered email address.</p>
          </div>

          <div className="actions">
            <button 
              onClick={() => window.open('https://chat.whatsapp.com/L9IrPNBGEXtFXdO0jaSkmX', '_blank')}
              className="whatsapp-btn"
            >
              <MessageCircle size={20} /> Join WhatsApp Group
            </button>
            <button onClick={() => navigate('/')} className="outline-btn">
              Back to Home <ArrowRight size={18} />
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Success;
